import * as FIELD_NAME from 'constant/form-item-names'
import React, { useState, useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { editDataset } from 'action/dataset'
import { Form, Modal } from 'antd'
import PropTypes from 'prop-types'
import DatasetForm from 'view/page/dataset-management/component/dataset-form'
import { getArticleDescription, resetState } from 'action/article'
import FormModal from 'view/component/form-modal'
import * as NUMBER from 'constant/number'
import _ from 'lodash'

const { success, error } = Modal

const buildSuccessObject = (response) => ({
  centered: true,
  content: `${response.title} has been successfully edited${response.is_draft ? ' and saved as a draft.' : '.'}`,
  title: 'Dataset edited'
})

const buildErrorObject = (response) => ({
  centered: true,
  content: response.message,
  title: 'An Error has occured'
})

const getDatasetForm = (form, dataset) => (
  <DatasetForm
    dataset={dataset}
    form={form}
  />
)

const EditDataset = ({ dataset, editDataset, getArticleDescription, submitting, resetState }) => {
  useEffect(() => {
    dataset.category_uuid = _.compact(dataset.category_uuid)
  }, [dataset])
  const [visible, setVisible] = useState(false)
  const [form] = Form.useForm()
  const handleClick = () => {
    setVisible(true)
    getArticleDescription(dataset.uuid)
  }

  const handleSubmit = () => {
    form.validateFields().then(async (values) => {
      const response = await editDataset({ ...values, description_meta: form.getFieldValue(FIELD_NAME.DESCRIPTION_META), template_uuid: form.getFieldValue(FIELD_NAME.TEMPLATE_UUID), uuid: dataset.uuid })
      setVisible(false)
      resetState()
      !response.error ? success(buildSuccessObject(response)) : error(buildErrorObject(response))
    }).catch(({ errorFields }) => form.scrollToField(errorFields[NUMBER.ZERO].name[NUMBER.ZERO]))
  }

  return (
    <>
      <a onClick={handleClick}>Edit Dataset</a>
      <FormModal
        handleSubmit={handleSubmit}
        loading={submitting}
        onCancel={() => {
          setVisible(false)
          resetState()
          form.setFieldsValue(dataset)
        }}
        title='Edit Dataset'
        visible={visible}
        width={NUMBER.EIGHTEEN_HUNDRED}
      >
        {getDatasetForm(form, dataset)}
      </FormModal>
    </>
  )
}

EditDataset.propTypes = {
  dataset: PropTypes.object,
  editDataset: PropTypes.func,
  getArticleDescription: PropTypes.func,
  resetState: PropTypes.func,
  submitting: PropTypes.bool
}

const mapStateToProps = (state) => ({
  submitting: state.loader.datasetSubmitting
})

const mapDispatchToProps = (dispatch) => ({
  editDataset: bindActionCreators(editDataset, dispatch),
  getArticleDescription: bindActionCreators(getArticleDescription, dispatch),
  resetState: bindActionCreators(resetState, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(EditDataset)
